module.exports = __webpack_public_path__ + "img/img_cx4.8d6d23e8.jpg";